var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "searchBox" } },
    [
      _c(
        "div",
        {
          staticClass: "box news-box",
          staticStyle: { background: "#FAFAFA", padding: "20px 80px" }
        },
        [
          _c(
            "el-form",
            { staticClass: "searchBox", attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "searchContent",
                  staticStyle: { width: "80%" },
                  attrs: { label: "" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入要搜索的内容",
                      "auto-complete": "off"
                    },
                    model: {
                      value: _vm.query.content,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "content", $$v)
                      },
                      expression: "query.content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "warning" },
                      on: {
                        click: function($event) {
                          return _vm.handelNormalSearch()
                        }
                      }
                    },
                    [_vm._v("检索")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogFormVisible = true
                        }
                      }
                    },
                    [_vm._v("高级检索")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "recomomed" }, [
            _c(
              "ul",
              [
                _vm._m(0),
                _vm._v(" "),
                _vm._l(_vm.recomomedList, function(item, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handelFastSearch(item)
                          }
                        }
                      },
                      [_vm._v(_vm._s(item))]
                    )
                  ])
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clear" }),
          _vm._v(" "),
          _vm.tableData && _vm.tableData.length > 0
            ? _c("div", { staticClass: "searchResultBox" }, [
                _c(
                  "ul",
                  _vm._l(_vm.tableData, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        on: {
                          click: function($event) {
                            return _vm.handelDetail(item)
                          }
                        }
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "title" }, [
                            _c("div", { staticClass: "t-title" }, [
                              _vm._v(_vm._s(item.title))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "r-title" }, [
                              _vm._v(
                                _vm._s(_vm._f("typeFormat")(item.textType))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "t-content" }, [
                            _vm._v(
                              _vm._s(_vm._f("getSimpleText")(item.textContent))
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "t-footer" }, [
                            _c("div", { staticClass: "l-link" }),
                            _vm._v(" "),
                            _c("div", { staticClass: "r-time" }, [
                              _vm._v(
                                _vm._s(_vm._f("dateFormat")(item.createTime))
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clear" })
                        ])
                      ]
                    )
                  }),
                  0
                )
              ])
            : _c("div", { staticClass: "noMessage" }, [
                _vm._v("\n      抱歉，没有找到与“\n      "),
                _c("span", { staticStyle: { color: "red" } }, [
                  _vm._v(_vm._s(_vm.query.content))
                ]),
                _vm._v(" ”相关的内容。\n      "),
                _vm._m(1)
              ]),
          _vm._v(" "),
          _vm.tableData && _vm.tableData.length > 0
            ? _c(
                "div",
                { staticClass: "page" },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.query.current,
                      "page-sizes": [5, 10, 20, 50, 100, 500],
                      "page-size": _vm.query.size,
                      layout: "total, sizes, prev, pager, next, jumper",
                      total: _vm.query.total,
                      background: ""
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "高级搜索",
            visible: _vm.dialogFormVisible,
            width: "475px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.query } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "搜索关键词",
                    "label-width": _vm.formLabelWidth
                  }
                },
                [
                  _c("el-input", {
                    attrs: { autocomplete: "off", size: "samll" },
                    model: {
                      value: _vm.query.content,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "content", $$v)
                      },
                      expression: "query.content"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "检索字段",
                    "label-width": _vm.formLabelWidth
                  }
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.query.type,
                        callback: function($$v) {
                          _vm.$set(_vm.query, "type", $$v)
                        },
                        expression: "query.type"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("全部")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("标题")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("正文")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 3 } }, [_vm._v("作者")])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "每页显示",
                            "label-width": _vm.formLabelWidth
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "" },
                              model: {
                                value: _vm.query.size,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "size", $$v)
                                },
                                expression: "query.size"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "10条", value: 10 }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "20条", value: 20 }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "50条", value: 50 }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "100条", value: 100 }
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "500条", value: 500 }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { attrs: { span: 12 } })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "排序字段",
                            "label-width": _vm.formLabelWidth
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "", size: "samll" },
                              model: {
                                value: _vm.query.sortColumn,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "sortColumn", $$v)
                                },
                                expression: "query.sortColumn"
                              }
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "日期", value: "CREATE_TIME" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "", "label-width": "30px" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.query.sortType,
                                callback: function($$v) {
                                  _vm.$set(_vm.query, "sortType", $$v)
                                },
                                expression: "query.sortType"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: "DESC" } }, [
                                _vm._v("降序")
                              ]),
                              _vm._v(" "),
                              _c("el-radio", { attrs: { label: "ASC" } }, [
                                _vm._v("升序")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "日期范围",
                    "label-width": _vm.formLabelWidth
                  }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "value-format": "yyyy-MM-dd hh:mm:ss",
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始日期",
                      "end-placeholder": "结束日期"
                    },
                    model: {
                      value: _vm.query.timeRange,
                      callback: function($$v) {
                        _vm.$set(_vm.query, "timeRange", $$v)
                      },
                      expression: "query.timeRange"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handelSeniorSearch }
                },
                [_vm._v("搜索")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [_c("span", [_vm._v("推荐关键词：")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { "margin-top": "30px" } }, [
      _c("p", [_vm._v("建议：")]),
      _vm._v(" "),
      _c("p", [_vm._v("检查输入是否正确")]),
      _vm._v(" "),
      _c("p", [_vm._v("简化输入词")]),
      _vm._v(" "),
      _c("p", [_vm._v("尝试其他相关词，如同义、近义词等.")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0fd5576", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0fd5576","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/search/index.vue
// module id = null
// module chunks = 